import { StylesConfig } from 'react-select';

export const selectStyles: StylesConfig = {
  container: (base, { isDisabled }) => ({
    ...base,
    pointerEvents: 'all',
    fontSize: '18px',
    lineHeight: '24px',
    cursor: isDisabled
      ? "url('@/shared/assets/images/cursors/notAllowed.svg'), not-allowed"
      : 'default',
  }),
  control: (base, { isFocused, isDisabled, selectProps }) => {
    const borderColor = selectProps['aria-invalid']
      ? 'var(--redrose)'
      : 'rgba(var(--bg3-rgb), .2)';

    return {
      ...base,
      pointerEvents: isDisabled ? 'none' : 'all',
      borderRadius: 26,
      backgroundColor: 'transparent',
      borderColor: isFocused ? 'var(--purpleflat)' : borderColor,
      borderWidth: 2,
      boxShadow: 'none',
      cursor: 'pointer',
      color: selectProps['aria-invalid'] ? 'red' : 'green',
      ':hover': {
        color: 'var(--black)',
        borderColor: selectProps['aria-invalid']
          ? 'var(--redrose)'
          : 'var(--purpleflat)',
      },

      // for mobile
      maxHeight: 'calc(100vh - 300px)',
      overflow: 'auto',
    };
  },
  singleValue: (base, { isDisabled, selectProps }) => {
    const valueColor = isDisabled ? 'var(--greytext)' : 'var(--bw)';

    return {
      ...base,
      color: selectProps['aria-invalid'] ? 'var(--redrose)' : valueColor,
    };
  },
  input: (base) => ({
    ...base,
    color: 'var(--bw)',
    padding: 0,
    margin: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 0,
    marginRight: '8px',
    color: 'var(--black)',
  }),
  dropdownIndicator: (base, { isDisabled, selectProps }) => {
    const indicatorColor = selectProps['aria-invalid']
      ? 'var(--redrose)'
      : 'var(--bw)';

    return {
      ...base,
      padding: '8px',
      margin: '3px 8px 3px 0',
      color: isDisabled ? 'var(--greytext)' : indicatorColor,
      display: 'flex',
      ':hover': {
        color: 'var(--purpleflat)',
      },
    };
  },
  valueContainer: (base) => ({
    ...base,
    padding: 0,
    margin: '11px 8px 11px 16px',
  }),
  placeholder: (base, { selectProps }) => ({
    ...base,
    color: selectProps['aria-invalid'] ? 'var(--redrose)' : 'var(--greytext)',
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: 'var(--wtop)',
    borderRadius: '24px',
    overflow: 'hidden',
    boxShadow: 'var(--menu-shadow)',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 10000,
  }),
  menuList: (base) => ({
    ...base,
    padding: '0',
  }),
  option: (base) => ({
    ...base,
    padding: '12px 16px',
    backgroundColor: 'transparent',
    borderRadius: '24px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 18px center',
    wordWrap: 'break-word',
    color: 'var(--bw)',
    cursor: 'pointer',
    ':active': {
      backgroundColor: 'transparent',
    },
    ':hover': {
      boxShadow: 'inset 0 0 0 2px var(--purpleflat)',
    },
    ':not(:last-child)': {
      marginBottom: '4px',
    },
  }),
  multiValue: (base) => ({
    ...base,
    gap: 8,
    borderRadius: 24,
    backgroundColor: 'rgba(var(--grey10-rgb), 0.4)',
    border: 'none',
  }),
  multiValueLabel: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: 0,
    paddingLeft: 8,
    color: 'var(--grey9)',
  }),
  multiValueRemove: (base) => ({
    ...base,
    backgroundColor: 'transparent',
    color: 'var(--grey9)',

    ':hover': {
      color: 'var(--redrose)',
    },
  }),
};
